import Skolen1 from '../../../assets/Projects/skolen/Skolen 1.webp';
import Skolen2 from '../../../assets/Projects/skolen/Skolen 2.webp';
import Skolen3 from '../../../assets/Projects/skolen/Skolen 3.webp';
import Skolen4 from '../../../assets/Projects/skolen/Skolen 4.webp';

import GT1 from '../../../assets/Projects/GT/GT1.webp';
import GT2 from '../../../assets/Projects/GT/GT2.webp';
import GT3 from '../../../assets/Projects/GT/GT3.webp';
import GT4 from '../../../assets/Projects/GT/GT4.webp';

import Casa1 from '../../../assets/Projects/Casa/Casa1.webp';
import Casa2 from '../../../assets/Projects/Casa/Casa2.webp';
import Casa3 from '../../../assets/Projects/Casa/Casa3.webp';

import Covabra1 from '../../../assets/Projects/Covabra/Covabra1.webp';
import Covabra2 from '../../../assets/Projects/Covabra/Covabra2.webp';
import Covabra3 from '../../../assets/Projects/Covabra/Covabra3.webp';

import Netflix1 from '../../../assets/Projects/Netflix/Netflix1.webp';
import Netflix2 from '../../../assets/Projects/Netflix/Netflix2.webp';

import typescript from '../../../assets/icons/techs/typescript.svg';
import styledComponents from '../../../assets/icons/techs/styled-components.svg';
import sass from '../../../assets/icons/techs/sass.svg';

import reactIcon from '../../../assets/icons/techs/React.svg';
import vtex from '../../../assets/icons/techs/vtex.svg';
import javascript from '../../../assets/icons/techs/javascript.svg';
import node from '../../../assets/icons/techs/nodejs.svg';
import docker from '../../../assets/icons/techs/docker.svg';
import angular from '../../../assets/icons/techs/angular.svg';
import vue from '../../../assets/icons/techs/vue.svg';

export const projectImages = {
  skolen: [
    { id: 1, src: Skolen1 },
    { id: 2, src: Skolen2 },
    { id: 3, src: Skolen3 },
    { id: 4, src: Skolen4 },
  ],
  gtGroup: [
    { id: 1, src: GT1 },
    { id: 2, src: GT2 },
    { id: 3, src: GT3 },
    { id: 4, src: GT4 },
  ],
  casa: [
    { id: 1, src: Casa1 },
    { id: 2, src: Casa2 },
    { id: 3, src: Casa3 },
  ],
  covabra: [
    { id: 1, src: Covabra1 },
    { id: 2, src: Covabra2 },
    { id: 3, src: Covabra3 },
  ],
  netflix: [
    { id: 1, src: Netflix1 },
    { id: 2, src: Netflix2 },
  ],
};

export const projectTechs = {
  skolen: [
    { id: 1, src: typescript, alt: 'Typescript' },
    { id: 2, src: reactIcon, alt: 'React' },
    { id: 3, src: styledComponents, alt: 'Styled Components' },
    { id: 4, src: sass, alt: 'Sass' },
  ],
  gtGroup: [
    { id: 1, src: javascript, alt: 'javascript' },
    { id: 2, src: sass, alt: 'sass' },
  ],
  casa: [
    { id: 1, src: javascript, alt: 'javascript' },
    { id: 2, src: typescript, alt: 'Typescript' },
    { id: 3, src: sass, alt: 'Sass' },
    { id: 4, src: vtex, alt: 'vtex' },
  ],
  covabra: [
    { id: 1, src: javascript, alt: 'javascript' },
    { id: 2, src: typescript, alt: 'Typescript' },
    { id: 3, src: sass, alt: 'Sass' },
    { id: 4, src: vtex, alt: 'vtex' },
    { id: 5, src: styledComponents, alt: 'styledComponents' },
  ],
  netflix: [
    { id: 1, src: javascript, alt: 'javascript' },
    { id: 2, src: sass, alt: 'Sass' },
  ],
};
